<template lang="pug">
  AppLayout(:title="title")
    DataTable(ref="dataTable", title="Translations", endpoint="translations", :filters="filters", :params="params" searchable)
      template(v-slot:buttons)
        Button(type="primary", @click="newTranslation()") NEW TRANSLATION
      template(v-slot:tabs)
        DataTableTabs(v-model="params.filters.only_missing")
          DataTableTab(:value="false") All Translations
          DataTableTab(:value="true") Missing Translations
      template(v-slot:rows="rows")
        DataTableRow(v-for="(row, i) in rows", :key="i", :row="row")
          DataTableColumn(icon="key", icon-prefix="far", title="Key", sortable="key", width="max") #[code.font-medium.text-sm {{ row.key }}]
          DataTableColumn(title="description", sortable="description") {{ row.description }}
          DataTableColumn(icon="flag-usa", icon-prefix="far", width="max", title="Languages")
            div.flex.items-center.space-x-2.text-lg(:class="{'text-warning': row.values_count !== locales.length, 'text-success': row.values_count === locales.length}")
              Icon(:icon="row.values_count !== locales.length ? 'exclamation-triangle' : 'square-check'")
              span {{ row.values_count }}
          DataTableColumn(icon="clock", title="Updated", sortable="updated_at", width="max") {{ row.updated_at | datetime }}
          template(v-slot:actions)
            button(@click="editTranslation(row)").p-2: Icon(icon="pencil")
</template>

<script>
import AddGlobalTagModal from "@/modals/GlobalTags/AddGlobalTagModal"
import { MediaIcon } from "@syntax51/app-kit"
import EditTranslationModal from "../../modals/Translations/EditTranslationModal.vue"
import NewTranslationModal from "../../modals/Translations/NewTranslationModal.vue"

export default {
  components: {
    MediaIcon
  },
  metaInfo() {
    return { title: this.title, bodyAttrs: { class: "page-global-tags" } }
  },
  data: () => ({
    title: "Translations",
    filters: {
      query: ""
    },
    params: {
      filters: {
        only_missing: false
      }
    },
    locales: []
  }),
  async created() {
    let response = await this.$api.get("translations/locales")
    this.locales = Array.isArray(response.data) ? response.data : []
  },
  methods: {
    async newTranslation() {
      if (await this.$modal.show(NewTranslationModal, { locales: this.locales })) {
        this.$refs.dataTable.reload()
      }
    },
    async addGlobalTag() {
      if (await this.$modal.show(AddGlobalTagModal)) {
        this.$refs.dataTable.reload()
      }
    },
    async editTranslation(translation) {
      if (
        await this.$modal.show(EditTranslationModal, {
          locales: this.locales,
          endpoint: `translations/${translation.id}`
        })
      ) {
        this.$refs.dataTable.reload()
      }
    },
    async deleteGlobalTag(tag) {
      if (
        await this.$modal.confirm({
          type: "danger",
          message: `Are you sure you want to delete global tag **${tag.name}**?`,
          buttonText: "Delete"
        })
      ) {
        if (await this.$api.delete(`global-tags/${tag.id}`)) {
          this.$notification.success(`Global tag **${tag.name}** successfully deleted.`)
          this.$refs.dataTable.reload()
        }
      }
    }
  }
}
</script>
